$(document).ready(function () {


$(document).on("click", "a.youtube-pop-video", function(event) {
  
event.preventDefault();
  var attrval = $(this).attr("href");
  if(attrval != ""){
  $(".pop-up-video video").attr('src',attrval);
  $(".pop-up-video").show();
  $("html").addClass("lock-all");
    if($(this).hasClass("with-html-data")){
      $(".pop-up-video").addClass("with-html-dt-pp");
      
      var includedDivs = $(this).parents(".single-block-video").children().not('.image-pop-up-v').clone(); 
      $(".pop-up-video.with-html-dt-pp .pop-up-video-data-vis").html("");
      $(".pop-up-video.with-html-dt-pp .pop-up-video-data-vis").html(includedDivs)
    }
    else{
      $(".pop-up-video").removeClass("with-html-dt-pp");
    }
  }
}); 
$(document).on("click", ".pop-up-video", function(e) {
  
 if (e.target == this){
    $(".pop-up-video").hide();
    $(".pop-up-video video").attr('src','');
    $("html").removeClass("lock-all");
   $(".pop-up-video").removeClass("with-html-dt-pp");
  }
});
   $('.pop-up-video video').on('click', function(event) {
    event.stopPropagation();
  });
  $(document).on("click", ".close-with-iframe #close-main-iframe", function(event) {
    $(".pop-up-video").hide();
    $(".pop-up-video video").attr('src','');
    $("html").removeClass("lock-all");
    $(".pop-up-video").removeClass("with-html-dt-pp");
  });
  

  
//   $(document).on('click', '.mfr-product__top ul.slick-dots button', function () {
//   $('.mfr-product__top .product-top__images-thumbnails .slick-current').trigger('click');
// });

//   $(".product-top__images").on('change.flickity', function(event, index) {
//   // Target the li based on index (assuming zero-based index)
    
//   var $targetLi = $(".product-top__images-thumbnails .product-top__images-thumbnail").eq(index); // Replace selector accordingly
 
//   // Check if it does NOT have the required class (e.g., 'active')
//   if (!$targetLi.hasClass('slick-current')) {
//     $targetLi.trigger('click');
//   }
// });
$(".size-dropdown-parent").on("click",function(){
  $(this).parents(".size-option-with-dropdown").find(".size-option-details").slideToggle();
  $(this).toggleClass("active-size-variant");
})

  $(document).on('click', function (event) {
  if (!$(event.target).closest('.size-option-with-dropdown').length) {
    if($(".size-dropdown-parent").hasClass("active-size-variant")){
      $(".size-dropdown-parent").removeClass("active-size-variant");
      $(".size-option-details").slideUp();
    }
  }
});

  
    $(".quickview_modal_dialog .quick_product_images").flickity("destroy"),
        $(".menu_arrow").on("click", function () {
            $(this).siblings("ul").slideToggle(),
                $(this).toggleClass("open"),
                $(this).parent(".mobile-main-menu li ").siblings().children("ul").hide(),
                $(this).parents(".mobile-main-menu li").siblings().children("span").removeClass("open"),
                $(this).siblings("ul").children("li").children("ul").hide(),
                $(this).siblings("ul").children("li").children("span").removeClass("open");
        }),
        $(document).on("click", ".search_close", (e) => {
            e.preventDefault(), $(".mfr-search-results").hide(), $(".mfr-search-widget").removeClass("show-result"), $("header .mfr-search-widget [data-mfr-search-input]").val("");
        }),
        $("footer .accordion-title.heading").on("click", function () {
            $(this).hasClass("active")
                ? ($(this).removeClass("active"), $(this).next().toggle())
                : ($("footer .accordion-title.heading").removeClass("active"), $("footer .accordion-content").hide(), $(this).addClass("active"), $(this).next().toggle());
        });
    setTimeout(function(){
        
      // $(".mfr-product__top .product-top__images").flickity('destroy');
        $(".mfr-product__top .product-top__images:not(.slick-initialized)").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: !1,
                arrows: !1,
                dots: !1,
              asNavFor: '.product-top-cell__images .product-top__images-thumbnails',
               responsive: [
                   
                    { breakpoint: 750, settings: { arrows: !1 }},
                ],
            }),
        $(".product-top-cell__images .product-top__images-thumbnails:not(.slick-initialized)").slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: !1,
                arrows: !1,
                dots: !1,
              asNavFor: '.mfr-product__top .product-top__images ',
              focusOnSelect: true,
                responsive: [
                   
                    { breakpoint: 750, settings: { dots: !0 }},
                ],
            }),
            $(".product-top-cell__images .product-top__images-thumbnails .slick-dots li").length > 2
                ? $(".product-top-cell__images .product-top__images-thumbnails .slick-dots").removeClass("hide")
                : $(".product-top-cell__images .product-top__images-thumbnails .slick-dots").addClass("hide");
          
    }, 400);

  let counter = 0;
let interval = setInterval(function () {
    counter++;
    if ($(".mfr-product__top .product-top__images .product-top__image").first().height() < 150) {
        
        $(".mfr-product__top .product-top__images.slick-initialized").slick('unslick');
        $(".product-top-cell__images .product-top__images-thumbnails.slick-initialized").slick('unslick');

        $(".mfr-product__top .product-top__images:not(.slick-initialized)").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            dots: false,
            asNavFor: '.product-top-cell__images .product-top__images-thumbnails',
            responsive: [
                { breakpoint: 750, settings: { arrows: false } },
            ],
        });

        $(".product-top-cell__images .product-top__images-thumbnails:not(.slick-initialized)").slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            dots: false,
            asNavFor: '.mfr-product__top .product-top__images',
            focusOnSelect: true,
            responsive: [
                { breakpoint: 750, settings: { dots: true } },
            ],
        });

        $(".product-top-cell__images .product-top__images-thumbnails .slick-dots li").length > 2
            ? $(".product-top-cell__images .product-top__images-thumbnails .slick-dots").removeClass("hide")
            : $(".product-top-cell__images .product-top__images-thumbnails .slick-dots").addClass("hide");

        
    }
    if (counter >= 6) {
        clearInterval(interval);
    }
}, 1000);
   
    // function t() {
    //     clearInterval(e);
    // }
    if (
        ($(".product_reviews tbody")
            .not(".slick-initialized")
            .slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: !1,
                arrows: !1,
                dots: !0,
                responsive: [
                    { breakpoint: 1199, settings: { slidesToShow: 3 } },
                    { breakpoint: 767, settings: { slidesToShow: 2 } },
                    { breakpoint: 567, settings: { slidesToShow: 1 } },
                ],
            }),
        $(".product_reviews tbody .slick-dots li").length > 1 ? $(".product_reviews tbody .slick-dots").removeClass("hide") : $(".product_reviews tbody .slick-dots").addClass("hide"),
        $(window).resize(function () {
            $(".product_reviews tbody .slick-dots li").length > 1 ? $(".product_reviews tbody .slick-dots").removeClass("hide") : $(".product_reviews tbody .slick-dots").addClass("hide");
        }),
        $(".tab_content:first").show(),
        $(".tab_drawer_heading").click(function () {
            if ($(this).hasClass("d_active")) $(".tab_drawer_heading").removeClass("d_active"), $(".tab_content").hide();
            else {
                $(".tab_content").hide();
                var e = $(this).attr("rel");
                $("#" + e).fadeIn(), $(".tab_drawer_heading").removeClass("d_active"), $(this).addClass("d_active");
            }
        }),
        $(".move-multicolumn .images_with_text")
            .not(".slick-initialized")
            .slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                infinite: !1,
                arrows: !1,
                dots: !0,
                responsive: [
                    { breakpoint: 1199, settings: { slidesToShow: 4 } },
                    { breakpoint: 991, settings: { slidesToShow: 3 } },
                    { breakpoint: 749, settings: { slidesToShow: 1.75 } },
                ],
            }),
        $(".move-multicolumn .images_with_text .slick-dots li").length > 1 ? $(".move-multicolumn .images_with_text .slick-dots").removeClass("hide") : $(".move-multicolumn .images_with_text .slick-dots").addClass("hide"),
        $(window).resize(function () {
            $(".move-multicolumn .images_with_text .slick-dots li").length > 1 ? $(".move-multicolumn .images_with_text .slick-dots").removeClass("hide") : $(".move-multicolumn .images_with_text .slick-dots").addClass("hide");
        }),
        $(".pdp-multi-column .all_goals tbody")
            .not(".slick-initialized")
            .slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: !0,
                arrows: !1,
                dots: !0,
                responsive: [
                    { breakpoint: 1199, settings: { slidesToShow: 3 } },
                    { breakpoint: 767, settings: { slidesToShow: 2 } },
                    { breakpoint: 567, settings: { slidesToShow: 1 } },
                ],
            }),
        $(".pdp-multi-column .all_goals tbody .slick-dots li").length > 1 ? $(".pdp-multi-column .all_goals tbody .slick-dots").removeClass("hide") : $(".pdp-multi-column .all_goals tbody .slick-dots").addClass("hide"),
        $(window).resize(function () {
            $(".pdp-multi-column .all_goals tbody .slick-dots li").length > 1 ? $(".pdp-multi-column .all_goals tbody .slick-dots").removeClass("hide") : $(".pdp-multi-column .all_goals tbody .slick-dots").addClass("hide");
        }),
        $(".template-product .mfr-core__product-grid .product-grid__items")
            .not(".slick-initialized")
            .slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: !0,
                arrows: !0,
                dots: !0,
                responsive: [
                    { breakpoint: 1199, settings: { slidesToShow: 3, dots: !0 } },
                    { breakpoint: 1024, settings: { slidesToShow: 3, dots: !0, arrows: !1 } },
                    { breakpoint: 991, settings: { slidesToShow: 2, dots: !0, arrows: !1 } },
                ],
            }),
        $(".template-product .mfr-core__product-grid .product-grid__items .slick-dots li").length > 1
            ? $(".template-product .mfr-core__product-grid .product-grid__items .slick-dots").removeClass("hide")
            : $(".template-product .mfr-core__product-grid .product-grid__items .slick-dots").addClass("hide"),
        $(window).resize(function () {
            $(".template-product .mfr-core__product-grid .product-grid__items .slick-dots li").length > 1
                ? $(".template-product .mfr-core__product-grid .product-grid__items .slick-dots").removeClass("hide")
                : $(".template-product .mfr-core__product-grid .product-grid__items .slick-dots").addClass("hide");
        }),
        $(".collection_filter_tab h4").on("click", function () {
            $(this).hasClass("open") ? ($(this).removeClass("open"), $(this).next().toggle()) : ($(this).addClass("open"), $(this).next().toggle());
        }),
       
        $(".product-top__sticky-bar-actions button .price").html($(".product-top__submit .price").html()),
        setTimeout(function () {
          if($('.subscription-selector').length > 0){
         var load_price = $('.mfr-product__top .subscription-selector>label [name=purchase_selector]:checked+.subscription-selector__selector .subscription-selector__selector-price').text();
         $(".mfr-product__top .product-top__submit .price .money").text(load_price);
            $(".product-top__sticky-bar-price").html($(".product-top__submit .price").html()), $(".product-top__sticky-bar-actions button .price").html($(".product-top__submit .price").html());
          }
        }, 100),
        $(".product-top__submit .money").bind("DOMSubtreeModified", function () {
            $(".product-top__sticky-bar-price").html($(this).html()), $(".product-top__sticky-bar-actions button .price").html($(this).html());
        }),
        $(".quick-view-div").on("click", function (e) {
            e.preventDefault();
            var t = $(this).data("quick-link");
            $("." + t).addClass("quick-view-model-open"), $("." + t).show();
            var i = $("." + t)
                .find(".quick-subscription .subsave")
                .html();
            $("body").addClass("modal_open"),
                $("." + t)
                    .find(".product-card__price .money")
                    .html(i),
                $("." + t)
                    .find(".product-card__button")
                    .prop("disabled", !0),
                setTimeout(function () {
                    var e = $(".product-top__images").flickity();
                    e.flickity("destroy"), e.flickity();
                }, 200);
        }),
        $(".quick-close-btn").click(function () {
            $(".custom-quick-view-model-main").removeClass("quick-view-model-open"), $("body").removeClass("modal_open"), $(".custom-quick-view-model-main").hide();
        }),
        $(".custom-quick-view-model-main").on("click", function (e) {
            e.target === this && ($(".custom-quick-view-model-main").removeClass("quick-view-model-open"), $("body").removeClass("modal_open"), $(".custom-quick-view-model-main").hide());
        }),
        $(".quick-view-data .product-card__button").on("click", function () {
            $(".custom-quick-view-model-main").removeClass("quick-view-model-open"), $("body").removeClass("modal_open"), $(".custom-quick-view-model-main").hide();
        }),
        $(".selling-selection").change(function () {
            var e = $(this).find("option:selected"),
                t = e.val();
            e.text();
            var i = e.data("selling-index");
            $(".quick-view-model-open").find(".quick-view-sub").prop("checked", !1),
                $(".quick-view-model-open")
                    .find(".quick-view-sub[data-selling-index=" + i + "]")
                    .prop("checked", !0),
                "select" == t ? $(".quick-view-model-open").find(".product-card__button").prop("disabled", !0) : $(".quick-view-model-open").find(".product-card__button").prop("disabled", !1);
        }),
        $(".product-card__selling-plan input[type=radio][name=purchase_selector]").change(function () {
            "one-time" == this.value
                ? $(".quick-view-model-open").find(".product-card__button").prop("disabled", !1)
                : "select" == $(".quick-view-model-open .selling-selection").find(":selected").val()
                ? $(".quick-view-model-open").find(".product-card__button").prop("disabled", !0)
                : $(".quick-view-model-open").find(".product-card__button").prop("disabled", !1);
        }),
        $(".header__icon.cart").on("click", function (e) {
            var t = $("header").outerHeight();
            $(".is-visible .rebuy-cart__background, .is-visible .rebuy-cart__flyout").css("top", t),
                setTimeout(function () {
                    $(".rebuy-cart").hasClass("is-visible") &&
                        $(".empty_cart_product")
                            .not(".slick-initialized")
                            .slick({ dots: !0, infinite: !0, speed: 300, slidesToShow: 1, centerMode: !0, centerPadding: "130px", arrows: !1, responsive: [{ breakpoint: 480, settings: { centerPadding: "50px" } }] });
                }, 1e3);
        }),
        $("a.categories__link").each(function () {
            $(this).hasClass("active") &&
                ($(this).parents(".filter_categories").show(),
                $(this).parents(".filter_categories").prev().addClass("open"),
                "All" != $(this).text().trim() && ($(this).parents(".filter_categories").prev().text(), $(".collection_product_section").addClass("type-product-open")));
        }),
        $(".facet-checkbox>input[type=checkbox]").each(function () {
            !0 == $(this).prop("checked") && $(this).parents(".facets__disclosure").attr("open", "true");
        }),
        $(".all_column_text .column_text_inner")
            .not(".slick-initialized")
            .slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: !1,
                arrows: !1,
                dots: !1,
                responsive: [
                    { breakpoint: 768, settings: { slidesToShow: 2, dots: !0 } },
                    { breakpoint: 567, settings: { slidesToShow: 1.2, dots: !0 } },
                ],
            }),
        $("all_column_text .column_text_inner .slick-dots li").length > 1 ? $("all_column_text .column_text_inner .slick-dots").removeClass("hide") : $("all_column_text .column_text_inner .slick-dots").addClass("hide"),
        $(".mfr-product__top .subscription-selector").length > 1 &&
            "" != $(".mfr-product__top .subscription-selector>label [name=purchase_selector]:checked+.subscription-selector__selector .subscription-selector__selector-price[data-price]"))
    ) {
        var i = $(".mfr-product__top .subscription-selector>label [name=purchase_selector]:checked+.subscription-selector__selector .subscription-selector__selector-price").attr("data-price");
        $(".mfr-product__top .subscription-selector>label [name=purchase_selector]:checked+.subscription-selector__selector").addClass("data-price-select"),
            $(".mfr-product__top .product__price .price-item--regular .money").empty().append(i),
            $(".subscription-selector>label [name=purchase_selector]").on("click", function () {           
                if ("lsf-e-gift-card" !== $("body").attr("id")) {
                    var e = $(".mfr-product__top .subscription-selector>label [name=purchase_selector]:checked+.subscription-selector__selector .subscription-selector__selector-price").attr("data-price");
                    $(".mfr-product__top .subscription-selector__selector").removeClass("data-price-select"),
                        $(".mfr-product__top .subscription-selector>label [name=purchase_selector]:checked+.subscription-selector__selector").addClass("data-price-select"),
                        $(".mfr-product__top .product__price .price-item--regular .money").empty().append(e),
                        $(".product-top__sticky-bar-submit .price .money").text(e);
                }
            });
    }
    if (
        ($(".product-top__sticky-bar-submit .price").html($(".mfr-product__top .product-top__submit .price").html()),
        $(document).on("click", ".subscription-selector>label [name=purchase_selector],.mfr-product__top .quantity-selector__button", function () {
          
            setTimeout(function () {              
              if("disabled" != $(".mfr-product__top .product-top__submit button").attr("disabled")){
                
                "lsf-e-gift-card" != $("body").attr("id") &&
                    $(".subscription-selector label").each(function () {
                       if($(".quantity-selector__input").length > 0){
                         var e = $(this).find(".subscription-selector__selector-price").attr("data-price"),
                            t = e.replace(/[^0-9.]/g, ""),
                            i = e.match(/[^a-zA-Z0-9.]/g),
                            s = t * $(".quantity-selector__input").val();
                          $(this)
                            .find(".subscription-selector__selector-price")
                            .text(i + "" + s.toFixed(2));
                      } else{
                         var e = $(this).find(".subscription-selector__selector-price").attr("data-price"),
                            t = e.replace(/[^0-9.]/g, ""),
                            i = e.match(/[^a-zA-Z0-9.]/g),
                            s = t ;
                          $(this).find(".subscription-selector__selector-price").text(i + "" + s);
                      }                        
                    });
              }
            }, 10),
                setTimeout(function () {
                    if ("lsf-e-gift-card" != $("body").attr("id") || "disabled" != $(".mfr-product__top .product-top__submit button").attr("disabled")) {
                     
                        var e = $(".mfr-product__top .subscription-selector>label [name=purchase_selector]:checked+.subscription-selector__selector .subscription-selector__selector-price").text();
                        "" != e && ($(".mfr-product__top .product-top__submit .price .money").text(e), $(".product-top__sticky-bar-submit .price .money").text(e));
                    }
                }, 500);
        }),
        $('.variant-selector__selectors [type="radio"]').on("click", function () {
            var e = $(this).data("title");
            $(this).data("price").replace("<span class=money>", "").replace("</span>", ""), $(this).parents(".variant-selector__radios").find(".variant-selector__radios-label span").text(e);
            var t = [],
                i = [],
                s = [],
                o = [],
                c = [];
            $(".select_product_variants option").each(function () {
                t.push($(this).data("first-value")), i.push($(this).data("second-value"));
            }),
                $('.variant-selector__selectors [type="radio"]').each(function () {
                    if (!0 == $(this).prop("checked")) {
                        var e = $(this).data("title");
                        s.push(e);
                    }
                });
            var l = t,
                r = i;
            s.forEach(function (e) {
                l.indexOf(e) >= 0 && o.push(e), r.indexOf(e) >= 0 && c.push(e);
            });
            var a = o,
                d = c;
            -1 == $.inArray(a, t) &&
                -1 == $.inArray(d, i) &&
                ((a = a.toString()),
                (d = d.toString()),
                $(".select_product_variants option").removeClass("first_value"),
                $(".select_product_variants option").removeClass("second_value"),
                $(".select_product_variants option[data-first-value='" + a + "']").addClass("first_value"),
                $(".select_product_variants option[data-second-value='" + d + "']").addClass("second_value")),
                $(".select_product_variants option").removeAttr("selected"),
                $(".select_product_variants option").each(function () {
                    if ($(this).hasClass("first_value second_value")) {
                        $(this).attr("selected", "selected"), $(this).parents(".product-top__form").find('[name="id"]').val($(this).data("id"));
                        var e = $(this).data("price").replace("<span class=money>", "").replace("</span>", "");
                        $("span.price-item.price-item--regular .money").text(e), $(".mfr-product__top .product-top__submit button.button .price .money").text(e);
                    }
                });
        }),
        $(".categories_type_link").on("click", function () {
            var e = $(this).data("first-href"),
                t = $(this).data("handle");
            $(this).hasClass("active")
                ? 1 == $(".categories_type_link.active").length
                    ? ($(".lsf-nutrition-all-data").removeClass("hide"), $(".categories_type_link").removeClass("active"), $(".categories_type_link_first").addClass("active"))
                    : ($("#" + t).addClass("hide"), $(this).removeClass("active"))
                : ($(".pro-msg").hide(),
                  e == location.pathname
                      ? ($(".categories_type_link_first").removeClass("active"),
                        $(this).addClass("active"),
                        $(".lsf-nutrition-all-data").hasClass("hide") || $(".lsf-nutrition-all-data").addClass("hide"),
                        $("#" + t).removeClass("hide"),
                        0 === $("#" + t).find(".product-grid__item:visible").length &&
                            $("#" + t)
                                .find(".pro-msg")
                                .show(),
                        $(this).hasClass("categories_type_link_first") &&
                            ($(".lsf-nutrition-all-data").removeClass("hide"),
                            $(".categories_type_link").removeClass("active"),
                            $(".categories_type_link_first").addClass("active"),
                            setTimeout(function () {
                                $(".lsf-nutrition-all-data").each(function () {
                                    var e = $(this).attr("id");
                                    0 === $("#" + e).find(".product-grid__item:visible").length &&
                                        $("#" + e)
                                            .find(".pro-msg")
                                            .show();
                                });
                            }, 200)))
                      : ((location.href = e + "?type=" + t), localStorage.setItem("col-handle", t)));
        }),
        localStorage.getItem("col-handle") == location.search.split("type=")[1] &&
            ($(".categories_type_link").each(function () {
                var e = localStorage.getItem("col-handle"),
                    t = $(this).data("handle");
                t == e &&
                    ($(".categories_type_link_first").removeClass("active"),
                    $(this).addClass("active"),
                    $(".lsf-nutrition-all-data").addClass("hide"),
                    "all" == t ? $(".lsf-nutrition-all-data").removeClass("hide") : $("#" + t).removeClass("hide"));
            }),
            localStorage.setItem("col-handle", "")),
        0 == $("#MainContent").children().length)
    ) {
        var s = $(window).height(),
            o = $("header").outerHeight(),
            c = $("footer").height();
        $("#MainContent").css("min-height", s - (o + c)),
            $(window).resize(function () {
                var e = $(window).height(),
                    t = $("header").outerHeight(),
                    i = $("footer").height();
                $("#MainContent").css("min-height", e - (t + i));
            });
    }
    $("predictive-search").click(function () {
        $(this).addClass("show-result");
    }),
        $(document).on("click", ".product-top__image-modal-overlay", function () {
            $(".product-top__image-modal-close").trigger("click");
        }),
        $(document).on("click", function (e) {
            $(e.target).closest(".product-top__image-modal").length || $(e.target).hasClass("product-top__image-modal-overlay") || $(e.target).hasClass("product-top__image") || $(".product-top__image-modal-close").trigger("click");
        });
    $(document).on("change", '.variant-selector__selectors label input[type="radio"]', function () {
        var d_title = $(this).data("title");
        $(".variant-selector--radio .variant-selector__radios-label span[data-label]").text(d_title);
        $('variant-radios input[value="' + d_title + '"]').trigger("click");
        $(".product-top__form").load(location.href + " .product-top__form>*", function () {
            // Optionally: Add any additional initialization if needed
            if (!$(".variant-selector.variant-selector--radio").hasClass("is-inview")) {
                $(".variant-selector.variant-selector--radio").addClass("is-inview");
            }
            if ($(".product-form__add-button").attr("disabled")) {
                $(".klaviyo-bis-trigger").show();
            } else {
                $(".klaviyo-bis-trigger").hide();
            }
        });
    });
});
